// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"d82d4465","769":"897ac103"}[chunkId] + ".chunk.js";
};